/* ============================================================
   BAHJIA WISHLIST — Logique favoris (localStorage)
   ============================================================ */

const BH_WL_KEY = 'bahjia_wishlist';

// ── Lire / écrire ──
function bhWlGet() {
  try { return JSON.parse(localStorage.getItem(BH_WL_KEY)) || []; }
  catch { return []; }
}
function bhWlSet(list) {
  localStorage.setItem(BH_WL_KEY, JSON.stringify(list));
}

// ── Ajouter / retirer ──
function bhWlToggle(handle) {
  let list = bhWlGet();
  if (list.includes(handle)) {
    list = list.filter(h => h !== handle);
  } else {
    list.push(handle);
  }
  bhWlSet(list);
  return list.includes(handle);
}

function bhWlHas(handle) {
  return bhWlGet().includes(handle);
}

// ── Met à jour l'état visuel de tous les boutons ──
function bhWlUpdateButtons() {
  document.querySelectorAll('.bh-wl-btn[data-wl-handle]').forEach(btn => {
    const handle = btn.dataset.wlHandle;
    btn.classList.toggle('bh-wl-active', bhWlHas(handle));
    btn.setAttribute('aria-label', bhWlHas(handle) ? 'Retirer des favoris' : 'Ajouter aux favoris');
  });
}

// ── Init boutons ──
function bhWlInitButtons() {
  document.querySelectorAll('.bh-wl-btn[data-wl-handle]').forEach(btn => {
    if (btn.dataset.wlInit) return;
    btn.dataset.wlInit = '1';

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.wlHandle;
      bhWlToggle(handle);
      bhWlUpdateButtons();

      // Animation pop
      btn.classList.remove('bh-wl-pop');
      void btn.offsetWidth;
      btn.classList.add('bh-wl-pop');
      btn.addEventListener('animationend', () => btn.classList.remove('bh-wl-pop'), { once: true });
    });
  });
  bhWlUpdateButtons();
}

// ── Page Favoris : afficher les produits ──
async function bhWlRenderPage() {
  const grid = document.getElementById('bh-wl-grid');
  const empty = document.getElementById('bh-wl-empty');
  if (!grid) return;

  const handles = bhWlGet();

  if (handles.length === 0) {
    grid.style.display = 'none';
    if (empty) empty.style.display = 'flex';
    return;
  }

  if (empty) empty.style.display = 'none';
  grid.style.display = 'grid';
  grid.innerHTML = '<p style="grid-column:1/-1;text-align:center;color:#aaa;font-size:13px;">Chargement...</p>';

  // Fetch chaque produit via l'API Shopify
  const products = await Promise.all(
    handles.map(handle =>
      fetch(`/products/${handle}.js`)
        .then(r => r.ok ? r.json() : null)
        .catch(() => null)
    )
  );

  const valid = products.filter(Boolean);

  if (valid.length === 0) {
    bhWlSet([]);
    grid.style.display = 'none';
    if (empty) empty.style.display = 'flex';
    return;
  }

  grid.innerHTML = valid.map(p => {
    const img = p.featured_image || '';
    const price = (p.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    return `
      <div class="bh-wl-card-wrap" style="position:relative;">
        <a href="/products/${p.handle}" class="bh-wl-card">
          <div class="bh-wl-card-img">
            ${img ? `<img src="${img}" alt="${p.title}" loading="lazy">` : ''}
          </div>
          <div class="bh-wl-card-info">
            <span class="bh-wl-card-title">${p.title}</span>
            <span class="bh-wl-card-price">${price}</span>
          </div>
        </a>
        <button class="bh-wl-remove" data-remove="${p.handle}" aria-label="Retirer des favoris">
          <svg viewBox="0 0 24 24" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
        </button>
      </div>
    `;
  }).join('');

  // Boutons supprimer
  grid.querySelectorAll('.bh-wl-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const handle = btn.dataset.remove;
      let list = bhWlGet().filter(h => h !== handle);
      bhWlSet(list);
      bhWlRenderPage();
    });
  });
}

// ── Lancement ──
document.addEventListener('DOMContentLoaded', () => {
  bhWlInitButtons();
  bhWlRenderPage();

  // Observer pour les cartes ajoutées dynamiquement
  const observer = new MutationObserver(() => bhWlInitButtons());
  observer.observe(document.body, { childList: true, subtree: true });
});
